<template>
  <div class="fillup">
    <button @click.left="$emit('fillup', true)">Nachladen</button>
  </div>
</template>

<script>
  export default {
    name: 'FillUp'
  }
</script>



// WEBPACK FOOTER //
// src/components/FillUp.vue